import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import { LoaderContext } from "../../Helpers/Context/Context";
import { Typography } from "@mui/material";
import { APICall } from "../../Helpers/Network/APICalls";
import moment from "moment";
import UnderConstruction from "../../Assets/Images/UnderConstruction.png";

const Dashboard = () => {
  let navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-content-center">
      <img src={UnderConstruction} alt="Under construction" />
    </div>
  );
};

export default Dashboard;
